import IAction from '../interfaces/action';
import IActionCreators from '../interfaces/actionCreators';
import TabName from '../interfaces/tabName';
export const actions = {
    setAllNotes: 'SET_ALL_NOTES',
    toggleEditModal: 'TOGGLE_EDIT_MODAL',
    toggleExportModal: 'TOGGLE_EXPORT_MODAL',
    setAllCategories: 'SET_ALL_CATEGORIES',
    toggleAllNotesListIsLoading: 'TOGGLE_ALL_NOTES_LIST_IS_LOADING',
    setSelectedPageId: 'SET_SELECTED_PAGE_ID',
    setVisibleTabName: 'SET_VISIBLE_TAB_NAME',
    setEditedCategoryName: 'SET_EDITED_CATEGORY_NAME',
    setExportName: 'SET_EXPORT_NAME',
    setSelectedCategoryId: 'SET_SELECTED_CATEGORY_ID',
    setNoSearchHits: 'SET_NO_SEARCH_HITS',
    toggleCreateModal: 'TOGGLE_CREATE_MODAL',
    toggleShareModal: 'TOGGLE_SHARE_MODAL',
    setNewCategoryName: 'SET_NEW_CATEGORY_NAME',
    toggleFunctionsToolbar: 'TOGGLE_FUNCTIONS_TOOLBAR',
    setSelectedNotes: 'SET_SELECTED_NOTES',
    setShareUrl: 'SET_SHARE_URL',
    setEmailsToShareTo: 'SET_EMAILS_TO_SHARE_TO',
    setDisplayNoteId: 'SET_DISPLAY_NOTE_ID',
    setToastBarMessage: 'SET_NOTES_TOASTBAR_MESSAGE',
    setToastBarType: 'SET_NOTES_TOASTBAR_TYPE',
    toggleToastBar: 'TOGGLE_TOASTBAR',
    toggleExportModalButton: 'TOGGLE_EXPORT_MODAL_BUTTON',
    toggleEditModalButton: 'TOGGLE_EDIT_MODAL_BUTTON',
    toggleCreateModalButton: 'TOGGLE_CREATE_MODAL_BUTTON',
    setExpandedState: 'SET_EXPANDED_STATE',
    clearSelectedNotes: 'CLEAR_SELECTED_NOTES'
}

export const actionCreators: IActionCreators = {
    setDisplayNoteId: (id) => {
        return { type: actions.setDisplayNoteId, payload: id }
    },
    setNewCategoryName: (name): IAction => {
        return { type: actions.setNewCategoryName, payload: name };
    },
    setShareUrl: (url): IAction => {
        return { type: actions.setShareUrl, payload: url };
    },
    setEmailsToShareTo: (url): IAction => {
        return { type: actions.setEmailsToShareTo, payload: url };
    },
    setExportName: (name): IAction => {
        return { type: actions.setExportName, payload: name };
    },
    setNoSearchHits: (hasNoSearchHits: boolean) => {
        return { type: actions.setNoSearchHits, payload: hasNoSearchHits}
    },
    setSelectedCategoryId: (id: string) => {
        return { type: actions.setSelectedCategoryId, payload: id };
    },
    setSelectedNotes: (id: string) => {
        return { type: actions.setSelectedNotes, payload: id }
    },
    toggleCreateModal: (): IAction => {
        return { type: actions.toggleCreateModal, payload: null }
    },
    toggleShareModal: (): IAction => {
        return { type: actions.toggleShareModal, payload: null }
    },
    toggleExportModal: (): IAction => {
        return { type: actions.toggleExportModal, payload: null }
    },
    toggleFunctionsToolbar: (): IAction => {
        return { type: actions.toggleFunctionsToolbar, payload: null }
    },
    setEditedCategoryName: (name): IAction => {
        return { type: actions.setEditedCategoryName, payload: name };
    },
    toggleEditModal: (): IAction => {
        return { type: actions.toggleEditModal, payload: null }
    },
    setAllNotes: (notes: any[]): IAction => {
        return { type: actions.setAllNotes, payload: notes };
    },
    setAllCategories: (categories: any[]): IAction => {
        return { type: actions.setAllCategories, payload: categories };
    },
    toggleAllNotesListIsLoading: (): IAction => {
        return { type: actions.toggleAllNotesListIsLoading, payload: null };
    },
    setSelectedPageId: (number): IAction => {
        return { type: actions.setSelectedPageId, payload: number };
    },
    setVisibleTabName: (name: TabName): IAction => {
        return { type: actions.setVisibleTabName, payload: name };
    },
    setToastBarMessage: (msg) => {
        return { type: actions.setToastBarMessage, payload: msg };
    },
    setToastBarType: (type: 'info' | 'warn' | 'success') => {
        return { type: actions.setToastBarType, payload: type };
    },
    toggleToastBar: () => {
        return { type: actions.toggleToastBar, payload: null };
    },
    toggleExportModalButton: () => {
        return { type: actions.toggleExportModalButton, payload: null };
    },
    toggleEditModalButton: () => {
        return { type: actions.toggleEditModalButton, payload: null };
    },
    toggleCreateModalButton: () => {
        return { type: actions.toggleCreateModalButton, payload: null };
    },
    clearSelectedNotes: () => {
        return { type: actions.clearSelectedNotes, payload: null };
    }
}